export default __webpack_public_path__ + "static/media/recorte_12.ab0f89e9.JPG";